import InnerComponent from '@Components/Admin/BusinessUnits';
import orgContainer from '@Components/AppContainer';

const BusinessUnitsAdmin = () => ((orgContainer(InnerComponent)));
export default BusinessUnitsAdmin;
